<button #infoButton mat-button class="button info" title="Info" (click)="showInfoPopover()" [style]="getBackgroundColor()">
  <img src="assets/ic_information_blk.svg" class="icon" />
</button>
<div class="backdrop" [ngClass]="{showing: infoPopoverShowing}" (click)="hideInfoPopover()"></div>
<div #popover class="popover" [ngClass]="{showing: infoPopoverShowing}" [style]="getInfoPopoverPosition()">
  <div class="popover-content">
    <div class="header">{{header}}</div>
    <div *ngFor="let helpItem of contextItems">
      <div class="subheader">{{helpItem.title}}</div>
      <div class="text">{{helpItem.description}}</div>
    </div>
  </div>
</div>
